import { render, staticRenderFns } from "./OrganizationPrompt.vue?vue&type=template&id=66435b1d&scoped=true&"
import script from "./OrganizationPrompt.vue?vue&type=script&lang=js&"
export * from "./OrganizationPrompt.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPrompt.vue?vue&type=style&index=0&id=66435b1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66435b1d",
  null
  
)

export default component.exports